import React, { FC } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import SelectInputWithCategories from '../../../sharedModules/form/components/SelectInputWithCategories';

import { FillablePdfField } from '../../../sharedModules/models';
import { SelectOptionWithCategory } from '../../../sharedModules/form/model';

import axios from '../../../sharedModules/utils/axios.utils';

interface FillableFieldSelectorProps {
  field: FillablePdfField;
  designationOptions: SelectOptionWithCategory[];
  afterUpdate: () => void;
}

const FillableFieldSelector: FC<FillableFieldSelectorProps> = (props) => {
  const { field, designationOptions, afterUpdate } = props;

  const handleDesignationChange = async (value: string) => {
    await axios.put(`/fillable_pdf_fields/${field.id}`, { designation: value });
    afterUpdate();
  };

  return (
    <Grid item xs={12} md={6}>
      <Grid container>
        <Grid item xs={5}>
          <Typography variant="body1">{field.field_name}</Typography>
        </Grid>
        <Grid item xs={6}>
          <SelectInputWithCategories
            label="Designation"
            choices={designationOptions}
            value={field.designation}
            valueChanged={(value: string) => handleDesignationChange(value)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FillableFieldSelector;
